import React from "react";
import CommonNavbar from "../components/CommonNavbar/CommonNavbar";
import CommonFooter from "../components/CommonFooter/CommonFooter";
import DetailsOfProducts from "../components/ProductDetails/DetailsOfProducts";
import RelatedProducts from "../components/ProductDetails/RelatedProducts";

const ProductDetail = () => {
  return (
    <div>
      <CommonNavbar hidebtn="d-none" showbtn="d-flex" />
      <DetailsOfProducts />
      <RelatedProducts heading="Related" heading2="Products" />
      <CommonFooter />
    </div>
  );
};

export default ProductDetail;
